import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'invalid-account-level-notification',
  templateUrl: './invalid-account-level-notification.component.html',
  styleUrls: ['./invalid-account-level-notification.component.scss']
})
export class InvalidAccountLevelNotificationComponent {
  @Input() message: string;
  @Input() needToUpgrade: boolean;

  @Output() openContactSupport: EventEmitter<any> = new EventEmitter();
  @Output() upgradeAccountEvt: EventEmitter<any> = new EventEmitter();

  constructor(private _userService: UserService) {
  }

  get isSsoUser(): boolean {
    return this._userService.isSsoUser;
  }

  contactSupport() {
    this.openContactSupport.emit();
  }

  startTrial() {
    this.upgradeAccountEvt.emit({
      startTrial: true
    });
  }

  upgradeAccount() {
    this.upgradeAccountEvt.emit({
      startTrial: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/invalid-account-level-notification/invalid-account-level-notification.component.ts